import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Colors from '../colors';
const StyledProgressBar = styled.View`
  background-color: ${props => props.backgroundColor};
  width: 100%; 
  height: 6px;
  border-radius: 4px;
`;
const StyledProgress = styled.View`
  background-color: ${props => props.color}; 
  width: ${props => props.progress}%;
  height: 6px;
  border-radius: 4px;
`;

function ProgressBar(props) {
  return /*#__PURE__*/React.createElement(StyledProgressBar, {
    backgroundColor: props.backgroundColor
  }, /*#__PURE__*/React.createElement(StyledProgress, {
    progress: props.progress,
    color: props.color
  }));
}

ProgressBar.defaultProps = {
  progress: 0,
  color: Colors.advanceBlue400,
  backgroundColor: Colors.lightGray300
};
ProgressBar.propTypes = {
  progress: PropTypes.number,
  color: PropTypes.string,
  backgroundColor: PropTypes.string
};
export default ProgressBar;
//# sourceMappingURL=index.js.map